import { render } from "./OkrugList.vue?vue&type=template&id=6f879352&scoped=true"
import script from "./OkrugList.vue?vue&type=script&lang=js"
export * from "./OkrugList.vue?vue&type=script&lang=js"

import "./OkrugList.vue?vue&type=style&index=0&id=6f879352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f879352"]])

export default __exports__